import { Link } from "react-router-dom";
import { BRAND, PROPERTIES } from "../properties";

export const ErthFooter = () => (
  <footer data-testid="erth-footer" className="bg-erth-black pb-10 pt-16 text-erth-white/70">
    <div className="mx-auto max-w-7xl px-6 sm:px-8">
      <div className="grid gap-12 border-b border-erth-white/10 pb-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <img src={BRAND.logoWhite} alt="erth. escapes" className="h-12 w-auto" data-testid="erth-footer-logo" />
          <p className="mt-6 max-w-sm font-body text-base font-light leading-relaxed">
            Thoughtfully crafted spaces that harmonize with nature. Homes and escapes for living, celebrating and
            reconnecting.
          </p>
        </div>
        <div className="md:col-span-4">
          <p className="mb-5 font-head text-sm font-semibold lowercase text-erth-white">contact</p>
          <ul className="flex flex-col gap-3 font-body text-base font-light">
            <li><a href={BRAND.phoneHref} data-testid="erth-footer-phone" className="transition-opacity hover:opacity-60">{BRAND.phone}</a></li>
            <li><a href={BRAND.whatsappHref} target="_blank" rel="noopener noreferrer" data-testid="erth-footer-whatsapp" className="transition-opacity hover:opacity-60">{BRAND.whatsapp} (WhatsApp)</a></li>
            <li><a href={`mailto:${BRAND.email}`} data-testid="erth-footer-email" className="transition-opacity hover:opacity-60">{BRAND.email}</a></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="mb-5 font-head text-sm font-semibold lowercase text-erth-white">projects</p>
          <ul className="flex flex-col gap-3 font-body text-base font-light">
            {PROPERTIES.filter((p) => p.live).map((p) => (
              <li key={p.slug}><Link to={`/${p.slug}`} data-testid={`erth-footer-${p.slug}`} className="transition-opacity hover:opacity-60">{p.name}</Link></li>
            ))}
            <li><Link to="/journal" data-testid="erth-footer-journal" className="transition-opacity hover:opacity-60">Journal</Link></li>
          </ul>
        </div>
      </div>
      <div className="flex flex-col justify-between gap-3 pt-8 font-body text-sm font-light text-erth-white/40 sm:flex-row">
        <p>© 2026 erth. escapes. All rights reserved.</p>
        <p>Spaces that harmonize with nature.</p>
      </div>
    </div>
  </footer>
);
